import NiceModal, { useModal } from '@ebay/nice-modal-react'
import UnmarkPurchaseModal from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/UnmarkPurchaseModal'
import { Reservation } from 'src/types/reservation'
import QuantityCallout from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/UnmarkPurchaseModal/components/QuantityCallout'
import { showUnmarkedAsPurchasedToast } from 'src/routes/(registry)/registry/(gift-tracker-revamp)/components/GiftDetailsDrawer/UnmarkedAsPurchasedToast'
import useGetRegistry from 'src/routes/(subdomains)/(my)/[slug]/hooks/useGetRegistry'
import css from './DeleteFavorModal.styles.scss'
import { DeleteFavorModalProps } from './DeleteFavorModal.types'

const TOAST_TEXT = 'Favor deleted.'

const DeleteFavorModal = NiceModal.create(
  ({ reservation }: DeleteFavorModalProps) => {
    const modal = useModal()
    const { registry } = useGetRegistry(reservation.registryId.toString())

    const resolveModal = (res?: Reservation) => {
      modal.resolve(res)
      modal.hide()
    }

    const handleUnmarkedAsPurchased = (res: Reservation) => {
      showUnmarkedAsPurchasedToast(registry, TOAST_TEXT)
      resolveModal(res)
    }

    const handleClose = () => resolveModal()

    return (
      <UnmarkPurchaseModal
        handleClose={handleClose}
        handleDismount={modal.remove}
        isOpen={modal.visible}
        reservation={reservation}
        onUnmarkedAsPurchased={handleUnmarkedAsPurchased}
      >
        <p className={css.DeleteFavorModal__Body}>
          Here's what you need to know:
        </p>
        <ol className={css.DeleteFavorModal__NumberedList}>
          <li>This favor will become available on your registry again.</li>
          <li>
            We'll remove this gift from your gift tracker and thank you list.
          </li>
        </ol>
        <QuantityCallout />
      </UnmarkPurchaseModal>
    )
  }
)

export default DeleteFavorModal
